import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _sliderVariationStrat;
import { PRE_DEFINED_VARIATIONS, SWIPER_EFFECT } from '../../../../constants/globalConstants';

// Define strategies for each pre-defined variation
export var sliderVariationStrategies = (_sliderVariationStrat = {}, _defineProperty(_sliderVariationStrat, PRE_DEFINED_VARIATIONS.DEFAULT, {
  effect: SWIPER_EFFECT.SLIDE.NAME
}), _defineProperty(_sliderVariationStrat, PRE_DEFINED_VARIATIONS.CORPORATE, {
  effect: SWIPER_EFFECT.FADE.NAME
}), _defineProperty(_sliderVariationStrat, PRE_DEFINED_VARIATIONS.FULL_WIDTH, {
  effect: SWIPER_EFFECT.SLIDE.NAME,
  parallaxOnScroll: true
}), _sliderVariationStrat);